import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckoutService } from '../../core/checkout/checkout.service';
import { FooterComponent } from '../../layout/footer/footer.component';
import { HeaderComponent } from '../../layout/header/header.component';
import { FooterNavComponent } from '../../shared/components/footer-nav/footer-nav.component';
import { IdentificationCardComponent } from '../../shared/components/identification-card/identification-card.component';
import { VisitService } from '../../core/visit/visit.service';
import { QrErrorCopy, qrErrorCopy } from '../../core/visit/qr-error-copy';

@Component({
  selector: 'app-qr-error-manual',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    FooterNavComponent,
    IdentificationCardComponent,
  ],
  templateUrl: './qr-error-manual.component.html',
  styleUrl: './qr-error-manual.component.scss',
})
export class QrErrorManualComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly visitService = inject(VisitService);
  private readonly checkoutService = inject(CheckoutService);

  readonly isCheckout = this.route.snapshot.data['journey'] === 'checkout';

  readonly scanRoute = this.isCheckout ? '/checkout/scan-qr' : '/scan-qr';

  readonly manualCardTitle = this.isCheckout
    ? 'Rechercher\nmon nom'
    : "S'identifier\nmanuellement";

  /**
   * Snapshot of the failure copy, captured ONCE when this screen mounts (same
   * failure as `/qr-error`, per SPECS §4.2). A live computed would flash the
   * generic "QR code non reconnu" copy when the inactivity timeout clears the
   * visit flow just before redirecting to the accueil.
   */
  readonly copy = signal<QrErrorCopy>(
    this.isCheckout
      ? {
          title: this.checkoutService.error()?.title ?? 'QR code non reconnu',
          subtitle: this.checkoutService.error()?.subtitle ?? 'Veuillez réessayer de nouveau',
        }
      : qrErrorCopy(this.visitService.current()?.flow),
  );

  identifyManually(): void {
    if (this.isCheckout) {
      // Parcours départ : aucune écriture sur VisitService (décision D3), et la
      // bascule mène à la RECHERCHE du visiteur, pas au clavier d'identification
      // — c'est la différence explicitement demandée par la spec §4.1.2.
      void this.router.navigate(['/checkout/search']);
      return;
    }

    // The visitor gave up on the QR scan and chose manual identification. Record
    // that switch here (mirroring the home "Je n'ai pas de QR code" card) so the
    // visit's identification_mode becomes MANUAL — their last action — and a
    // MANUAL row reaches wh_visit_history even if they leave before validating.
    this.visitService.updateFlow({ entryMethod: 'manual' });
    this.visitService.trackEvent('manual_identification');
    void this.router.navigate(['/visitor-identification']);
  }
}
